import React from 'react';
import { Stack, Box, useTheme } from '@mui/material';
import { withStyles } from '@material-ui/core';
import { VTypography } from '@venti-components';
import VIconButton from '../../../../Components/Buttons/IconButton/IconButton';
import MaterialIcon from '../../../../Venti-UI-Kit/VIcon/MaterialIcon';
import useArtistCard from './hook';
import ConfirmModal from '../../../../Venti-UI-Kit/Modals/ConfirmModal';
import styles from '../styles';

const ArtistCard = ({ classes, artist, onRemove }) => {
  const theme = useTheme();
  const { openModal, handleOpenModal, handleCloseModal, handleAccept } = useArtistCard(onRemove);

  return (
    <Stack direction="row" className={classes.container} alignItems="center" gap={2}>
      <Box className={classes.imageWrapper}>
        {artist.image && <img src={artist.image} alt={artist.name} className={classes.image} />}
      </Box>
      <VTypography variant="subtitle3">{artist.name}</VTypography>
      <VIconButton
        variant="outlined"
        Icon={<MaterialIcon name="delete" color={theme.palette.error.main} />}
        color={theme.palette.error.main}
        onClick={handleOpenModal}
      />
      <ConfirmModal
        title="Eliminar artista"
        subtitle={`¿Estás seguro de que querés sacar a ${artist.name} del evento?`}
        open={openModal}
        handleClose={handleCloseModal}
        handleAccept={handleAccept}
        acceptLabel="Eliminar"
      />
    </Stack>
  );
};

export default withStyles(styles)(ArtistCard);
